import type { IconDef } from '../types';

/** A filled dot centred in the glyph box — a live-status marker coloured by its caller. */
export const statusDot: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M4 12a8 8 0 1 0 16 0a8 8 0 1 0 -16 0',
    },
  ],
};
